"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFileInfos = exports.remove = exports.download = exports.upload = exports.getAll = void 0;
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var fbase_1 = require("../firebase/fbase");
var StorageManager_1 = require("../storage/StorageManager");
var Admin = __importStar(require("../utils/Admin"));
var COLLECTION_NAME = 'FILEBOX';
function checkAdmin() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var currentUserId, isAdmin;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    currentUserId = (_a = fbase_1.authService.currentUser) === null || _a === void 0 ? void 0 : _a.email;
                    if (!currentUserId) {
                        return [2 /*return*/, Promise.reject(new Error('파일 보관함 - 로그인한 유저를 찾을 수 없습니다.'))];
                    }
                    return [4 /*yield*/, Admin.checkLevel(currentUserId)];
                case 1:
                    isAdmin = _b.sent();
                    if (!isAdmin) {
                        return [2 /*return*/, Promise.reject(new Error('파일 보관함 - 관리자 권한이 아닙니다.'))];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function get(id) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fbase_1.dbService.collection(COLLECTION_NAME).doc(id).get()];
                case 1: return [2 /*return*/, (_a.sent()).data()];
            }
        });
    });
}
function getAll() {
    return __awaiter(this, void 0, void 0, function () {
        var docs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, checkAdmin()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, fbase_1.dbService.collection(COLLECTION_NAME).get()];
                case 2: return [4 /*yield*/, (_a.sent()).docs];
                case 3:
                    docs = _a.sent();
                    return [2 /*return*/, lodash_1.default.map(docs, function (doc) {
                            var value = doc.data();
                            value.id = doc.id;
                            return value;
                        })];
            }
        });
    });
}
exports.getAll = getAll;
function updateInfo(originalCommonFile) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var user, fileInfo;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    user = (_a = fbase_1.authService.currentUser) === null || _a === void 0 ? void 0 : _a.email;
                    if (!user)
                        return [2 /*return*/];
                    fileInfo = lodash_1.default.cloneDeep(originalCommonFile);
                    fileInfo.id = undefined;
                    fileInfo.file = undefined;
                    fileInfo.duplication = undefined;
                    fileInfo.author = user;
                    fileInfo.updateTime = (0, moment_1.default)().format('YYYY-MM-DD HH:mm:ss');
                    if (!!originalCommonFile.id) return [3 /*break*/, 2];
                    return [4 /*yield*/, fbase_1.dbService.collection(COLLECTION_NAME).add(fileInfo)];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, fbase_1.dbService.collection(COLLECTION_NAME).doc(originalCommonFile.id).update(fileInfo)];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
function upload(files) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, checkAdmin()];
                case 1:
                    _a.sent();
                    if (lodash_1.default.isEmpty(files)) {
                        return [2 /*return*/, Promise.reject(new Error('업로드 할 파일 목록이 없습니다.'))];
                    }
                    return [4 /*yield*/, Promise.all(lodash_1.default.map(files, function (file) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!file.file) {
                                            return [2 /*return*/, Promise.reject(new Error('업로드 파일이 없습니다.'))];
                                        }
                                        // TODO(sangmuk): 업로드 파일 이름이 변경된 경우, storage에서 이전 파일을 삭제해야한다.
                                        return [4 /*yield*/, updateInfo(file)];
                                    case 1:
                                        // TODO(sangmuk): 업로드 파일 이름이 변경된 경우, storage에서 이전 파일을 삭제해야한다.
                                        _a.sent();
                                        return [4 /*yield*/, (0, StorageManager_1.uploadFile)("FileBox/".concat(file.name), file.file)];
                                    case 2:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.upload = upload;
function download(id) {
    return __awaiter(this, void 0, void 0, function () {
        var file;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, checkAdmin()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, get(id)];
                case 2:
                    file = _a.sent();
                    return [4 /*yield*/, (0, StorageManager_1.saveFromStorage)("FileBox/".concat(file.name), file.name)];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.download = download;
function remove(file) {
    return __awaiter(this, void 0, void 0, function () {
        var docRef;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, checkAdmin()];
                case 1:
                    _a.sent();
                    docRef = fbase_1.dbService.collection(COLLECTION_NAME).doc(file.id);
                    return [4 /*yield*/, docRef.delete()];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, (0, StorageManager_1.deleteFile)("FileBox/".concat(file.name))];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.remove = remove;
function parseFileInfos(newFiles) {
    return __awaiter(this, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getAll()];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, lodash_1.default.map(newFiles, function (newFile) {
                            var _a;
                            return ({
                                name: newFile.name,
                                size: newFile.size,
                                id: (_a = lodash_1.default.find(files, function (file) { return file.name === newFile.name; })) === null || _a === void 0 ? void 0 : _a.id,
                                author: '',
                                updateTime: '',
                                file: newFile,
                                duplication: !lodash_1.default.isEmpty(lodash_1.default.find(files, function (file) { return file.name === newFile.name; }))
                            });
                        })];
            }
        });
    });
}
exports.parseFileInfos = parseFileInfos;
//# sourceMappingURL=FileboxManager.js.map